<ng-container *ngIf="selectedApp && selectedApp.title == 'ERAM Keyboard'; else otherApp">
  <app-eram-lesson-analytics [psParams]="psParams" [dateData$]="api.dateRange$" [selectedApp]="selectedApp"></app-eram-lesson-analytics>
</ng-container>
<ng-template #otherApp>
  <ng-container *ngIf="selectedApp && selectedApp.title == 'Advanced Vectoring';else otherApp1">
    <app-basic-advance-analytic [dateData$]="api.dateRange$">
    </app-basic-advance-analytic>
  </ng-container>
  </ng-template>
  <!-- SG-7046 -->
  <ng-template #otherApp1>
    <ng-container *ngIf="selectedApp && selectedApp.title == 'Basic Vectoring';else otherApp2">
      <app-basic-analytics [dateData$]="api.dateRange$">
      </app-basic-analytics>
    </ng-container>
  </ng-template>
<ng-template #otherApp2>
    <ng-container *ngIf="selectedApp && selectedApp.title == 'STARS Keyboard';else otherApp3">
      <app-stars-lessons-analtics [psParams]="psParams" [userName]="data.username"  [dateData$]="api.dateRange$" [selectedApp]="selectedApp">
      </app-stars-lessons-analtics>
    </ng-container>
  </ng-template>
<ng-template #otherApp3>
    <div fxLayout="column" fxFlex="100%" fxLayoutGap="10px">
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between stretch" *ngIf="selectedApp && (selectedApp.title == 'ATC Phraseology' || selectedApp.name == 'ATC Phraseology') ">
    <app-atc-practice-set-consolidated-count-tab-analtics fxFlex="100%" style="display: flex;" [userName]="data.username" [dateData$]="api.dateRange$" [selectedApp]="selectedApp"></app-atc-practice-set-consolidated-count-tab-analtics>
  </div>
  <!-- Command Category (consolidated ratio) hidden per request
  <div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="space-between stretch" *ngIf="selectedApp && (selectedApp.title == 'ATC Phraseology' || selectedApp.name == 'ATC Phraseology') ">
    <app-atc-practice-set-consolidated-ratio-tab-analtics fxFlex="100%" style="display: flex;" [userName]="data.username" [dateData$]="api.dateRange$" [selectedApp]="selectedApp"></app-atc-practice-set-consolidated-ratio-tab-analtics>
  </div>
  -->
        <div fxLayout="row" fxLayout.lt-md="column" fxFlex="100%" fxLayoutGap="10px" *ngIf="key == 'pSetAnalytics'">
            <mat-card fxLayout="row" fxLayout.lt-md="row wrap" fxLayoutAlign="start center" fxFlex="80%" fxFlex.lt-md="100%">
                <span pointer (click)="exit.emit({exit: true})"><i class="fa fa-sticky-note route-icon"></i>{{psParams.previousPsetName ? psParams.previousPsetName : 'Practice Set Analytics'}}</span>
                <mat-icon>keyboard_arrow_right</mat-icon>
                <span pointer (click)="exit.emit({key: 'user'})"><i class="fa fa-user route-icon"></i>{{psParams.userName ? psParams.userName : 'User Details'}}</span>
                <mat-icon>keyboard_arrow_right</mat-icon>
                <span><i class="fa fa-sticky-note route-icon"></i>{{psParams.name ? psParams.name : 'Practice Set Analytics'}}</span>
            </mat-card>
            <mat-card fxLayout="row" fxLayoutAlign="center center" fxFlex="20%" fxFlex.lt-md="100%">
                <app-date-selector [selectedDateRange]="dateRangeType" (changeDate)="getDate($event);"></app-date-selector>
            </mat-card>
        </div>
        <div class="card-row" [ngClass]="['card-height']">
            <mat-card fxLayout="column" class="half-card" *ngIf="!data.username">
                <div fxLayoutAlign="space-between" fxLayout="row">
                    <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center">
                        Users/Nickname
                    </mat-card-subtitle>
                    <app-data-export (exportData)="getCsvData('users')" pointer></app-data-export>
                </div>
                <app-table fxLayout="row" fxFlex [data]="data.users" pointer *ngIf="data.users" [fix]="6" (rowClicked)="openUserDialog($event)"></app-table>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!data.users">
                    <mat-spinner diameter="20"></mat-spinner>
                </div>
            </mat-card>
            <mat-card fxLayout="column" class="half-card" *ngIf="data.username">
                <div fxLayoutAlign="space-between" fxLayout="row">
                    <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center">
                        Session Data
                    </mat-card-subtitle>
                    <app-data-export (exportData)="getCsvData('usersSessionData')" pointer></app-data-export>
                </div>
                <app-table fxLayout="row" fxFlex [data]="sessionData" pointer *ngIf="sessionData"
                    [fix]="6"></app-table>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!sessionData">
                    <mat-spinner diameter="20"></mat-spinner>
                </div>
            </mat-card>
            <mat-card fxLayout="column" class="half-card">
                <div fxLayoutAlign="space-between" fxLayout="row">
                    <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center">
                        LIST OF QUESTIONS/RECORDS
                    </mat-card-subtitle>
                    <app-data-export (exportData)="getCsvData('performance')" pointer></app-data-export>
                </div>
                    <app-table class="ques-records" fxFlex fxLayout="row" [data]="data.records" [tooltip]="2" *ngIf="data.records">
                    </app-table>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!data.records">
                    <mat-spinner diameter="20"></mat-spinner>
                </div>
            </mat-card>
        </div>
        <div class="card-row" [ngClass]="['card-height']">
            <mat-card fxLayout="column" class="half-card" fxLayoutGap="12px" *ngIf="!selectedApp || selectedApp.title != 'ERAM Keyboard'">
                <div fxLayout="row" fxLayoutAlign="space-between start">
                  <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center" *ngIf="dateType.type === 'Day'" style="margin-top:10px;">
                    LAST 1 MONTH'S DATA
                  </mat-card-subtitle>
                  <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center" *ngIf="dateType.type === 'Month'" style="margin-top:10px;">
                    LAST 24 MONTH'S DATA
                  </mat-card-subtitle>
                  <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center" *ngIf="dateType.type === 'Year'" style="margin-top:10px;">
                    LAST 5 YEAR'S DATA
                  </mat-card-subtitle>
              
                  <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="end start" fxLayoutGap="10px" fxFlex>
                    <div fxLayout="column" fxLayoutAlign="start center">
                      <div fxLayout="row" fxLayoutGap="5px">
                        <mat-form-field id="duration-dropdown" class="mrgn drpdown-chart-options" appearance="outline">
                          <mat-select [(ngModel)]="usageAnalyticsSelectedValue" name="usageAnalytics" (selectionChange)="changeAnalytics($event.value)">
                            <mat-option class="drp-options" *ngFor="let ua of usageAnalytics" [value]="ua.value">
                              {{ua.viewValue}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div fxLayout="column" fxLayoutAlign="end center" style="margin-top:6px">
                      <app-data-export (exportData)="getCsvData('usage')" pointer></app-data-export>
                    </div>
                  </div>
                </div>
                <app-highcharts 
                  #highchartsComponentMonth
                  [height]="'320px'" 
                  [marginTop]="'0px'" 
                  [maximumPoints]="5"
                  [totalLessionsSessions]="totalLessionsSessions"
                  [updateChart]="updateChartMonth">
                </app-highcharts>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!usageChartDatasets">
                  <mat-spinner diameter="20"></mat-spinner>
                </div>
              
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="usageChartDatasets && usageChartDatasets.length === 0">
                  No data found
                </div>
              </mat-card>
              
            <mat-card fxLayout="column" class="half-card" fxLayoutGap="12px">
                <div fxLayoutAlign="space-between" fxLayout="row">
                    <mat-card-subtitle cardHeader fxLayout="column" fxLayoutAlign="center">
                        LIVE SESSIONS
                    </mat-card-subtitle>
                    <div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="end start" fxLayoutGap="10px" fxFlex>
                      <div fxLayout="column" fxLayoutAlign="start center">
                        <div fxLayout="row" fxLayoutGap="5px">
                          <mat-form-field id="duration-dropdown" class="mrgn drpdown-chart-options" appearance="outline">
                            <mat-select [(ngModel)]="liveSessionUsageValue" name="liveSessionUsageAnalytics"
                              (selectionChange)="getLiveSessionRecords(dateValue)">
                              <mat-option class="drp-options" *ngFor="let ua of liveSessionStatus" [value]="ua.value">
                                {{ua.viewValue}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                      <div fxLayout="column" fxLayoutAlign="end center" style="margin-top:6px">
                        <app-data-export (exportData)="getCsvData('session')" pointer></app-data-export>
                      </div>
                    </div>
                    
                </div>
                <app-highcharts 
                  #highchartsComponentLiveSession
                  [height]="'320px'" 
                  [marginTop]="'30px'" 
                  [maximumPoints]="5"
                  [seriesType]="'column'"
                  [totalLessionsSessions]="totalLessionsSessions"
                  [updateChart]="updateChartLiveSession">
                </app-highcharts>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="!liveSessionChartDatasets">
                    <mat-spinner diameter="20"></mat-spinner>
                </div>
                <div fxLayout="row" fxLayoutAlign="center center" fxFlex *ngIf="liveSessionChartDatasets && liveSessionChartDatasets.length === 0">
                    No Live Sessions
                </div>
            </mat-card>
        </div>
    </div>
</ng-template>

